import { post, get } from '@/utils/request'

// 登录
export function login(data) {
  return post('/login', data)
}

// 登出
export function logout() {
  return post('/logout')
}

// 获取用户信息
export function getUserInfo() {
  return get('/user/info')
}
